import React, { useEffect, useRef, useState } from "react";
import { StyledBox, StyledHr } from "../ContactOverview/ContactOverview";
import StyledText from "../../../components/StyledComponents/StyledText";
import { CorporateTheme } from "../../../utils/themes";
import { Button } from "../../../components/form/Button";
import NewEmailIcon from "../../../assets/icons/NewEmailIcon";
import styled from "styled-components";
import Avatar from "../../../components/Avatar/Avatar";
import ContactPlaceHolder from "../../../assets/images/contactPlaceHolder.png";
import ReplyIcon from "../../../assets/icons/ReplyIcon";
import ReplyAllIcon from "../../../assets/icons/ReplyAllIcon";
import { useTheme } from "../../../middleware/ThemeContext";

const Communication = () => {
  const { theme } = useTheme();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isTextOverflowing = el.scrollHeight > el.clientHeight;
      setIsOverflowing(isTextOverflowing);
    }
  }, []);
  return (
    <StyledBox theme={theme} className="px-3">
      <div className="d-flex align-items-center justify-content-between">
        <StyledText
          fontSize="16px"
          fontWeight={700}
          textColor={theme.CorporateTheme.colors.headerColor}
          className="mb-0 py-3"
        >
          Email Communication
        </StyledText>
      </div>
      <StyledHr theme={theme} />
      <div className="d-flex flex-column gap-2 my-3">
        <div className="d-flex align-items-center justify-content-between mb-2">
          <StyledText
            fontSize="18px"
            fontWeight={700}
            textColor={theme.CorporateTheme.colors.headerColor}
            className="mb-0 py-3"
          >
            Emails ({66})
          </StyledText>
          <Button theme={theme} type="button" $variant="add">
            <NewEmailIcon color={theme.CorporateTheme.colors.background} /> Create New Email
          </Button>
        </div>
        {[1, 2, 4, 5]?.map((mail, ind) => (
          <EmailBox theme={theme} className="overflow-y-auto">
            <div className="d-flex align-items-start justify-content-between">
              <div className="d-flex gap-2">
                <div>
                  <Avatar
                    name="Oliver Bennett"
                    imageUrl={ContactPlaceHolder}
                    size={44}
                  />
                </div>
                <div className="d-flex flex-column">
                  <StyledText
                    fontSize="16px"
                    fontWeight={600}
                    textColor={theme.CorporateTheme.colors.headerColor}
                    className="mb-1 "
                  >
                    Sarah Grey
                  </StyledText>

                  <StyledText
                    fontSize="13px"
                    fontWeight={400}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    className="mb-1"
                  >
                    <strong>To: </strong> markstep@test.com
                  </StyledText>
                  <StyledText
                    fontSize="13px"
                    fontWeight={400}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    className="mb-1"
                  >
                    <strong>Cc: </strong> Greg-matman456@test.com
                  </StyledText>
                </div>
              </div>
              <div className="d-flex gap-3">
                <div className="d-flex align-items-center gap-1 cursor-pointer">
                  <ReplyIcon color={theme.CorporateTheme.colors.paginationSelect} />
                  <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor={theme.CorporateTheme.colors.paginationSelect}
                  >
                    Reply
                  </StyledText>
                </div>
                <div className="d-flex align-items-center gap-1 cursor-pointer">
                  <ReplyAllIcon color={theme.CorporateTheme.colors.paginationSelect} />
                  <StyledText
                    fontSize="12px"
                    fontWeight={400}
                    textColor={theme.CorporateTheme.colors.paginationSelect}
                  >
                    Reply all
                  </StyledText>
                </div>
                <div>
                  <StyledText
                    fontSize="12px"
                    fontWeight={600}
                    className="font-lato"
                    textColor={theme.CorporateTheme.colors.headerColor}
                  >
                    2/6/2025 | 8:33 PM
                  </StyledText>
                </div>
              </div>
            </div>
            <div>
              <StyledText
                fontSize="14px"
                fontWeight={350}
                textColor={theme.CorporateTheme.colors.textSecondary}
                className="mb-0 py-3"
                ref={textRef}
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: isExpanded ? "unset" : 3,
                }}
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat.
              </StyledText>
              {/* {isOverflowing && (
                <button
                  onClick={() => setIsExpanded(!isExpanded)}
                  style={{
                    color: "blue",
                    fontSize: "14px",
                    fontWeight: 500,
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    padding: 0,
                    marginTop: "4px",
                  }}
                >
                  {isExpanded ? "Show less" : "Read more"}
                </button>
              )} */}
            </div>
          </EmailBox>
        ))}
      </div>
    </StyledBox>
  );
};

export default Communication;

const EmailBox = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `0.5px solid ${theme.CorporateTheme?.colors?.border}`,
  backgroundColor: theme.CorporateTheme?.colors?.headerBG,
  padding: '10px 23px',
  borderRadius: '4px',
}));
